export const AUDIO_EXTENSIONS = ['.mp3'];
export const MAX_AUDIO_SIZE = 25000000;

export const acceptAudioExtensionList = AUDIO_EXTENSIONS.join(',');
